module.exports = __webpack_public_path__ + "static/media/2-tendulkar.0a96489a.png";